import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComparitorOption, VitalFlagComparitors } from '../../models/vital_flags.model';

@Component({
  selector: 'app-measure-frequency',
  templateUrl: './measure-frequency.component.html',
  styleUrls: ['./measure-frequency.component.scss'],
})
export class MeasureFrequencyComponent implements OnInit, OnDestroy {
  @Input()
  measureFrequencyForm: UntypedFormGroup;

  @Input()
  disableFixedValue = true;

  selectedTooltip = '';
  comparitors: ComparitorOption[];

  private readonly destroy$ = new Subject<void>();

  private readonly tooltips: Record<string, string> = {
    [VitalFlagComparitors.FIXED]: 'Compares to a single number',
    [VitalFlagComparitors.DAYS]: 'Compares averages over a time period',
    [VitalFlagComparitors.MEASURES]: 'Compares over a certain number of prior measures',
  };

  constructor() {}

  ngOnInit(): void {
    this.setComparitors(this.disableFixedValue);
    this.measureFrequencyForm.get('comparitors').valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      const match = this.comparitors.find((c) => c.value === value);
      this.selectedTooltip = match ? match.tooltip : '';
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setComparitors(disableFixedValue: boolean): void {
    const values = disableFixedValue
      ? Object.values(VitalFlagComparitors).filter((flag) => flag !== VitalFlagComparitors.FIXED)
      : Object.values(VitalFlagComparitors);

    this.comparitors = values.map((value) => ({
      value,
      label: `${value.charAt(0).toLocaleUpperCase()}${value.substring(1).toLocaleLowerCase()}`,
      tooltip: this.tooltips[value] || '',
    }));
  }
}
